import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Screen from '../../utils/Screen';
import i18n from '../../i18n';
import { Divider, Link } from '@homeexchange/design';
import { CurrencyFormatter } from '../../utils/Intl';
import Transfert from '../../models/Transfert';

export default function PaymentMainProduct(props) {
    const { title, product } = props;
    const [features, setFeatures] = useState('');
    const [dropdownFeatures, setDropdownFeatures] = useState('');
    const [dropdownIsVisible, setDropdownVisibility] = useState(false);

    useEffect(() => {
        if (Screen.isMobile()) {
            const currentFeatures = props.features;

            if (currentFeatures.indexOf('<li>') === -1) {
                setFeatures(currentFeatures);
                return;
            }

            const splittedFeatures = currentFeatures.split('<li>');

            const elements = splittedFeatures
                .filter((item) => item !== '')
                .map((elmt) => {
                    return `<li>${elmt}`;
                });

            let formattedFeatures = '';
            let formattedDropdownFeatures = '';

            const nbElementsToDisplayOnMobile = product.type === 'renew-subscription' ? 0 : 2;

            elements.forEach((element, index) => {
                if (index < nbElementsToDisplayOnMobile) {
                    formattedFeatures = `${formattedFeatures}${element}`;
                } else {
                    formattedDropdownFeatures = `${formattedDropdownFeatures}${element}`;
                }
            });

            setFeatures(formattedFeatures);
            setDropdownFeatures(formattedDropdownFeatures);
        } else {
            setFeatures(props.features);
        }
    }, [props.features]);

    function handleOnDropdown() {
        setDropdownVisibility(!dropdownIsVisible);
    }

    // eslint-disable-next-line react/no-multi-comp
    function displayFooter() {
        const text = dropdownIsVisible
            ? i18n.t('billing:pitch-membership.hide-benefits')
            : i18n.t('billing:pitch-membership.show-benefits');

        return (
            <div className="pitch-footer">
                <Link onClick={handleOnDropdown} color="secondary" noUnderline={true}>
                    <i
                        className={classNames('fa', {
                            'fa-angle-down': !dropdownIsVisible,
                            'fa-angle-up': dropdownIsVisible
                        })}
                    />
                    {text}
                </Link>
            </div>
        );
    }

    return (
        <div className="pitch">
            <h3>{title}</h3>
            {product.type === 'renew-subscription' && (
                <>
                    <ul
                        className="mb-0"
                        dangerouslySetInnerHTML={{
                            __html: i18n.t(
                                `subscription:payment.membership.features.mr${
                                    product.isCollection ? '.collection' : ''
                                }`,
                                {
                                    loyaltyPrice: CurrencyFormatter.format(product.price, product.currency),
                                    price: CurrencyFormatter.format(product.originalPrice, product.currency),
                                    nb: Transfert.MOTIVES_VALUE[
                                        product.isCollection
                                            ? Transfert.MOTIVE_RENEW_SUBSCRIPTION_COLLECTION
                                            : Transfert.MOTIVE_RENEW_SUBSCRIPTION
                                    ]
                                }
                            )
                        }}
                    />
                    {dropdownIsVisible && <Divider space="small" />}
                </>
            )}

            <ul dangerouslySetInnerHTML={{ __html: features }}></ul>
            {dropdownIsVisible && <ul dangerouslySetInnerHTML={{ __html: dropdownFeatures }}></ul>}
            {Screen.isMobile() && displayFooter()}
        </div>
    );
}

PaymentMainProduct.propTypes = {
    title: PropTypes.string.isRequired,
    features: PropTypes.string.isRequired,
    product: PropTypes.object
};
